import { MapPin, Phone, MessageCircle, ArrowUpRight } from "lucide-react";
import { CITIES, waLink, PHONE_DISPLAY } from "@/lib/site";
import { Reveal, Stagger, StaggerItem } from "@/lib/motion";

export const ServiceArea = () => (
  <section id="atendimento" className="relative py-24 lg:py-32 bg-slate-50">
    <div className="max-w-7xl mx-auto px-4 md:px-8">
      <div className="grid lg:grid-cols-2 gap-12 items-center">
        <div>
          <Reveal>
            <p className="text-sm font-bold uppercase tracking-[0.2em] text-[#55c0e0] mb-4">Área de Atendimento</p>
            <h2 className="font-display text-3xl sm:text-4xl lg:text-5xl font-bold tracking-tight text-[#012a60] text-balance">
              Atendemos toda a Grande Florianópolis
            </h2>
            <p className="mt-5 text-slate-600 leading-relaxed max-w-lg">
              Está construindo, reformando ou precisa realizar manutenção em vidros? Nossa equipe está
              pronta para atender você com rapidez, qualidade e excelente acabamento.
            </p>
          </Reveal>

          <Stagger className="mt-8 flex flex-wrap gap-3">
            {CITIES.map((c) => (
              <StaggerItem key={c}>
                <span className="inline-flex items-center gap-1.5 rounded-full border border-slate-200 bg-white px-4 py-2 text-sm font-medium text-[#012a60]">
                  <MapPin size={13} className="text-[#55c0e0]" /> {c}
                </span>
              </StaggerItem>
            ))}
          </Stagger>

          <Reveal delay={0.2}>
            <div className="mt-9 flex flex-wrap items-center gap-4">
              <a href={waLink()} target="_blank" rel="noopener noreferrer" data-testid="area-orcamento-btn"
                className="group inline-flex items-center gap-2 rounded-full bg-[#012a60] px-7 py-4 font-bold text-white hover:bg-[#55c0e0] hover:text-[#012a60] transition-colors">
                Solicitar Orçamento
                <ArrowUpRight size={18} className="transition-transform group-hover:translate-x-0.5 group-hover:-translate-y-0.5" />
              </a>
              <a href={`tel:+5548996889862`} data-testid="area-phone"
                className="inline-flex items-center gap-2 rounded-full border border-[#012a60]/20 bg-white px-7 py-4 font-bold text-[#012a60] hover:border-[#55c0e0] transition-colors">
                <Phone size={17} className="text-[#55c0e0]" /> {PHONE_DISPLAY}
              </a>
            </div>
          </Reveal>
        </div>

        <Reveal delay={0.1}>
          <div className="relative rounded-3xl overflow-hidden ring-1 ring-black/5 shadow-2xl">
            <iframe
              title="Área de atendimento Vidraçaria Gabibox"
              data-testid="google-map"
              src="https://www.google.com/maps?q=São+José,+Santa+Catarina&z=10&output=embed"
              className="w-full h-[440px] border-0"
              loading="lazy"
              referrerPolicy="no-referrer-when-downgrade"
            />
            <a href={waLink()} target="_blank" rel="noopener noreferrer"
              className="absolute bottom-5 left-5 inline-flex items-center gap-2 rounded-full bg-[#25D366] px-5 py-3 font-bold text-white shadow-lg hover:opacity-90 transition-opacity">
              <MessageCircle size={16} /> Falar no WhatsApp
            </a>
          </div>
        </Reveal>
      </div>
    </div>
  </section>
);
